// frontend/src/samkalp-admin/DashboardHome.js
import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Spinner } from 'react-bootstrap';
import { getTenantHierarchy, getTenantDashboardMetrics, getTenantProjects } from '../api/api';

const DashboardHome = ({ slug }) => {
    const [hierarchy, setHierarchy] = useState(null);
    const [metrics, setMetrics] = useState(null);
    const [projectCount, setProjectCount] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            getTenantHierarchy(slug).catch(() => ({ data: null })),
            getTenantDashboardMetrics(slug).catch(() => ({ data: null })),
            getTenantProjects(slug).catch(() => ({ data: [] })),
        ]).then(([hierarchyRes, metricsRes, projectsRes]) => {
            setHierarchy(hierarchyRes.data);
            setMetrics(metricsRes.data);
            setProjectCount((projectsRes.data || []).length);
        }).finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;

    return (
        <div>
            <h4 className="fw-bold mb-1">{hierarchy?.tenant?.name || slug}</h4>
            <p className="text-muted mb-4">
                {hierarchy?.parent
                    ? <>Centre of <strong>{hierarchy.parent.name}</strong></>
                    : hierarchy?.children?.length > 0
                        ? <>Parent academy — {hierarchy.children.length} centre(s)</>
                        : 'Standalone tenant'}
            </p>

            <Row className="g-3 mb-4">
                {[
                    { label: 'Live Projects', value: projectCount ?? 0, colour: 'info' },
                    { label: 'Pending Reviews', value: metrics?.reviews?.pending || 0, colour: 'warning' },
                    { label: 'Total Projects (all stages)', value: metrics?.projects?.total || 0, colour: 'primary' },
                ].map(({ label, value, colour }) => (
                    <Col md={4} key={label}>
                        <Card className={`border-start border-4 border-${colour} shadow-sm`}>
                            <Card.Body>
                                <div className="text-muted x-small text-uppercase fw-bold">{label}</div>
                                <div className={`fs-3 fw-bold text-${colour}`}>{value}</div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {hierarchy?.children?.length > 0 && (
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-white fw-bold">Centres</Card.Header>
                    <Card.Body>
                        {hierarchy.children.map(c => (
                            <div key={c.id} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <div>
                                    <div className="fw-semibold">{c.name}</div>
                                    <div className="x-small text-muted">{c.slug}</div>
                                </div>
                                <Badge bg={c.status === 'active' ? 'success' : 'secondary'}>{c.status}</Badge>
                            </div>
                        ))}
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default DashboardHome;
